module.exports = __webpack_public_path__ + "static/media/default-building-small.4cf2f0c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/default-building-small.jpg
// module id = 1248
// module chunks = 0